module.exports = __webpack_public_path__ + "img/news_10-03-2021.a154220b.jpg";